export enum Authority {
  BSG = 'BSG',
  PROSPECT = 'prospect',
  SOLUTION_DEVELOPER = 'solutionDeveloper',
  OPERATIONS_MANAGER = 'operationsManager',
  CHANGE_APPROVER = 'changeApprover',
  READER = 'reader',
  IAC_READER = 'iacReader',
  RELEASE_MANAGER = 'release-manager',
  OPERATION_MANAGER = 'operation-manager',
  SERVICE_MANAGER = 'service-manager'
}
